import { Controller } from "@hotwired/stimulus"

// Handles dropdown menus
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close the dropdown when clicking outside
    document.addEventListener("click", this.clickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside)
  }

  clickOutside = (event) => {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  open() {
    this.menuTarget.classList.remove("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }
}